import React, { useState, useContext, useEffect } from 'react';
import { Button, Grid, Box, TextField, Typography, Snackbar, } from '@mui/material';
import { stLogin } from '../css/modal';
import { useNavigate } from 'react-router-dom'; 
import { AuthContext } from './AuthContext';
import axiosInstancePromise  from '../general/axiosConfig';

function FormLogin({ handleClick }) {
  const [formData, setFormData] = useState({
    nombre_usuario: '',
    password: ''
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { login } = useContext(AuthContext); 
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.post('/login-usuario', formData);
      console.log("Respuesta API", response);

      if (response.status === 200) {
          const { access_token, message } = response.data;
          login(access_token); 
          setSnackbarMessage(message || 'Inicio de sesión exitoso');
          setTimeout(() => navigate('/Principal'), 500);
      } else {
          setSnackbarMessage('Error al iniciar sesión. Intente de nuevo.');
      }
    } catch (error) {
      console.error('Error en la solicitud:', error);
      setSnackbarMessage('Error inesperado.');
    } finally {
      setOpenSnackbar(true);
    }
  };

  return (
    <Box sx={stLogin.formBox3}>
      <Typography mt={4} variant="h4" align="center" gutterBottom>
        Iniciar Sesión
      </Typography>
      <form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              name="nombre_usuario"
              label="Nombre de Usuario"
              variant="outlined"
              fullWidth
              value={formData.nombre_usuario}
              onChange={handleInputChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="pwd_hash"
              label="Contraseña"
              type="password"
              variant="outlined"
              fullWidth
              value={formData.pwd_hash}
              onChange={handleInputChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              fullWidth 
              sx={stLogin.buttonPrimary}
            >
              Ingresar
            </Button>
          </Grid>
        </Grid>
      </form>
      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={6000} 
        onClose={() => setOpenSnackbar(false)} 
        message={snackbarMessage}
      />
    </Box>
  );
}

export default function Login() {
  const [currentView, setCurrentView] = useState('login');

  const handleClick = (view) => setCurrentView(view);

  const { isAuthenticated, login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
        const storedPath = localStorage.getItem('currentPath');
        navigate(storedPath);
    }
  }, [isAuthenticated, navigate]);

  return (
    <Grid container justifyContent="center" alignItems="center" minHeight="100vh" 
      sx={{
        bgcolor: "secondary.lateral",
        minWidth: "300px", // Un ancho mínimo para pantallas muy pequeñas
        width: "100%", // Un ancho mínimo para pantallas muy pequeñas
      }}
    >
      {currentView === 'login' && <FormLogin handleClick={handleClick} />}
      <img 
        src="/LOGOKAI-FAVICON-02.png"
        alt="Logo" 
        style={{ 
          position: 'absolute', 
          bottom: '20px', 
          right: '20px', 
          width: '150px', 
          height: 'auto' 
        }} 
      />
    </Grid>
  );
}

